{
  "name": "gwclient",
  "version": "742.741",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "sssl": "ng serve  --ssl --ssl-key local.host\\key.pem --ssl-cert local.host\\cert.pem",
    "build": "ng build",
    "test": "cypress open --config-file=cypress/cypress.json",
    "lint": "eslint src/**/*.ts",
    "lint:fix": "eslint src/**/*.ts --fix",
    "standard": "ts-standard",
    "standard:fix": "ts-standard --fix",
    "e2e": "cypress open --config-file=cypress/cypress.json",
    "cy": "cypress open --config-file=cypress/cypress.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~17.3.12",
    "@angular/cdk": "~17.3.10",
    "@angular/common": "~17.3.12",
    "@angular/compiler": "~17.3.12",
    "@angular/core": "~17.3.12",
    "@angular/forms": "~17.3.12",
    "@angular/material": "~17.3.10",
    "@angular/material-luxon-adapter": "~17.3.10",
    "@angular/platform-browser": "~17.3.12",
    "@angular/platform-browser-dynamic": "~17.3.12",
    "@angular/router": "~17.3.12",
    "@mdi/angular-material": "~7.2.96",
    "he": "~1.2.0",
    "highcharts": "~12.2.0",
    "jwt-decode": "~4.0.0",
    "luxon": "3.6.1",
    "ol": "10.5.0",
    "rxjs": "~7.8.2",
    "tslib": "~2.8.1",
    "weekstart": "~2.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~17.3.16",
    "@angular/cli": "~17.3.16",
    "@angular/compiler-cli": "~17.3.12",
    "@types/he": "~1.2.3",
    "@types/luxon": "3.6.2",
    "@types/node": "~22.14.0",
    "@typescript-eslint/eslint-plugin": "~8.29.1",
    "@typescript-eslint/parser": "~8.29.1",
    "cypress": "~14.3.0",
    "eslint": "~9.24.0",
    "eslint-utils": "~3.0.0",
    "neostandard": "~0.12.1",
    "ts-node": "~10.9.2",
    "typescript": "~5.4.5"
  },
  "packageManager": "pnpm@10.8.0+sha512.0e82714d1b5b43c74610193cb20734897c1d00de89d0e18420aebc5977fa13d780a9cb05734624e81ebd81cc876cd464794850641c48b9544326b5622ca29971",
  "pnpm": {
    "onlyBuiltDependencies": [
      "cypress",
      "esbuild"
    ]
  }
}
